var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStep1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .836)",
    fill: "#FAA100",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fillOpacity: 0.1,
    cx: 29.987,
    cy: 30,
    rx: 29.987,
    ry: 30
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.976 17.45)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.735,
    cy: 6.887,
    rx: 6.705,
    ry: 6.887
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.515 25.827h10.36c-3.052-2.512-3.719-7.008-1.534-10.34a8.328 8.328 0 0 1-5.7-2.694C2.224 14.275.002 17.713 0 21.523v1.722c.004 1.424 1.128 2.578 2.515 2.582z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.735 19.8c0 3.33 2.626 6.027 5.867 6.027 3.24 0 5.867-2.698 5.867-6.026s-2.627-6.026-5.867-6.026c-3.239.003-5.864 2.7-5.867 6.026zm6.705-1.72v.86h.838a.85.85 0 0 1 .838.86.85.85 0 0 1-.838.862h-.838v.86a.85.85 0 0 1-.838.862.85.85 0 0 1-.838-.861v-.861h-.839a.85.85 0 0 1-.838-.861.85.85 0 0 1 .838-.861h.839v-.86a.85.85 0 0 1 .838-.862.85.85 0 0 1 .838.861z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep1);
export default __webpack_public_path__ + "static/media/step1.59acf38d5159ec44a139e7d572e4ec10.svg";
export { ForwardRef as ReactComponent };